import { useRef } from 'react';
import { useMountEffect } from '@/shared/hooks/useMountEffect';

/**
 * Reports an editor opening and closing, including an unmount while it is open.
 *
 * A table or header can unmount mid-edit (a tab switch, or a reseed that drops
 * its field) without ever committing, and an unreported close holds every idle
 * check for the rest of the session.
 */
export function useReportedEditorOpen(report: (open: boolean) => void) {
  const openRef = useRef(false);
  const reportRef = useRef(report);
  reportRef.current = report;
  useMountEffect(() => () => {
    if (openRef.current) reportRef.current(false);
  });
  return (open: boolean) => {
    openRef.current = open;
    report(open);
  };
}
